export default __webpack_public_path__ + "static/media/gaurav.14898dd5.png";